import { looksVersioned, resolveApiBaseUrl } from '@lubehub/api';

export const API_BASE_URL_VARIABLE = 'VITE_API_BASE_URL';

export function apiBaseUrl(): string {
  const resolved = resolveApiBaseUrl({
    variable: API_BASE_URL_VARIABLE,
    configured: import.meta.env.VITE_API_BASE_URL,
    fallback: import.meta.env.DEV ? 'http://localhost:8000/api/v1' : undefined,
  });

  warnIfSurprising(resolved);

  return resolved;
}

let warned = false;

function warnIfSurprising(baseUrl: string): void {
  if (!import.meta.env.DEV || warned) {
    return;
  }

  warned = true;

  if (import.meta.env.VITE_API_BASE_URL === undefined) {
    console.warn(
      `${API_BASE_URL_VARIABLE} is not set; using ${baseUrl} for development. ` +
        `Copy apps/web/.env.example to apps/web/.env to point it elsewhere.`,
    );
    return;
  }

  if (!looksVersioned(baseUrl)) {
    console.warn(
      `${API_BASE_URL_VARIABLE} is ${baseUrl}, which does not end in a version ` +
        `such as /api/v1. If requests come back as HTML or 404, this is why.`,
    );
  }
}
